<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { FormStatus } from "../formsV2/types";
import Modal from "@/components/modals/ModalContainer.vue";
import { auctionApi } from "~/api/auction";

const { t } = useI18n();

const emits = defineEmits<{
  (e: "on-referrer", input: { username: string; referralCode: string }): void;
  (e: "on-close"): void;
}>();

const loading = ref(false);

onMounted(() => {});

const referralCodeFormErrors = ref<FormStatus | null>(null);
const referralCode = ref<string>("");

const handleReferralCodeOnChange = async (value: string) => {
  referralCode.value = value;
  if (value.trim().includes(" ")) {
    referralCodeFormErrors.value = {
      type: "error",
      msg: t("pages.auth.form.errors.spaceNotAllowed"),
    };
  } else if (referralCodeFormErrors.value?.type === "error") {
    referralCodeFormErrors.value = null;
  }
};

const updateUsername = async () => {
  loading.value = true;
  try {
    const resp = await auctionApi.users.referrals.checkReferralCode.query({
      referralCode: referralCode.value.trim(),
    });
    if (!resp.exists) {
      referralCodeFormErrors.value = {
        type: "error",
        msg: t("pages.auth.form.errors.invalid-referral-code"),
      };
    } else {
      emitReferrer({
        username: resp.username as string,
        referralCode: referralCode.value.trim(),
      });
    }
  } catch (e) {
  } finally {
    loading.value = false;
  }
};

const emitReferrer = (input: { username: string; referralCode: string }) => {
  emits("on-referrer", input);
};

const handleClose = () => {
  emits("on-close");
};
</script>

<template>
  <Modal
    bgColor="bg-black"
    modalClasses=""
    :show="true"
    :showCloseButton="false"
    size="lg"
    title=""
  >
    <div class="flex flex-col items-center w-full gap-4">
      <div class="flex flex-col justify-center m-4 w-full gap-5 max-w-96">
        <div class="flex flex-col gap-1">
          <div class="font-medium text-center text-2xl mb-2">
            {{ t("pages.auth.form.signup.referral-placeholder") }}
          </div>
          <Input
            placeholder="ACBDE1245"
            :center-text="true"
            :state="referralCodeFormErrors"
            class="mt-4"
            @change="handleReferralCodeOnChange"
            :disabled="loading"
          />
        </div>

        <Button
          :disabled="referralCodeFormErrors?.type === 'error' || referralCode.trim().length === 0"
          :loading="loading"
          @click="updateUsername"
          size="sm"
          type="primary-blue"
          class="w-full"
        >
          {{ t("_shared.submit") }}
        </Button>
        <Button :loading="loading" @click="handleClose" size="sm" type="secondary" class="w-full">
          {{ t("_shared.cancel") }}
        </Button>
      </div>
    </div>
  </Modal>
</template>

<style scoped lang="scss"></style>
